import { useEffect } from 'react';
import { POLLING_DEFAULT_INTERVAL as pollingInterval } from '../../Constants';

export const usePolling = (pollingAction, interval = pollingInterval) => {
  const dataPolling = {};

  dataPolling.start = () => {
    dataPolling.idToStop = setInterval(() => {
      pollingAction();
    }, interval);
  };
  dataPolling.stop = () => clearInterval(dataPolling.idToStop);

  useEffect(() => {
    dataPolling.start();
    pollingAction();
  }, []);

  useEffect(() => {
    return () => {
      dataPolling.stop();
    };
  }, []);
};
